import { useEffect, useMemo, useState } from "react";
import Cookies from "universal-cookie";
import Typography from "@mui/material/Typography";
import {
  Box,
  ThemeProvider,
  IconButton,
  Chip,
  Menu,
  // Tooltip,
  styled,
  Button,
  Grid,
  Modal,
  TablePagination,
} from "@mui/material";
import launchIcon from "../../assets/images/launch-icon.svg";
import {
  QuickSearchToolbar,
  pageTheme,
  StyledDataGrid,
  CustomLoadingOverlay,
  ActionButton,
  SecondaryButton,
} from "../../ayudas/Themes";
import { Delete, MoreVert, Upcoming } from "@mui/icons-material";
import ModalAdvanceInfo from "./AdvanceInfo/AdvanceInfo";
import ModalCreate from "./ModalCreate/ModalCreate";
import { deleteIOC } from "../../Services/IOCExecution";
import { ConvertDateUtc } from "../../ayudas/GlobalData";
import { GridOverlay } from "@mui/x-data-grid-pro";
import GeneralModalDelete from "../../ayudas/CommonComponents/GeneralDeleteModal";
import axios from "axios";
import { env2 } from "../../ayudas/Instance";
import { endPoint } from "../../Services/EndPoint";
import AxiosFetch from "../../Services/FetchServices";
import { rolValidation } from "../../ayudas/ScriptsFunctions";
import TablePaginationActions from "../../ayudas/TablePaginations";

const ButtonLauncher = styled(Button)({
  padding: "10px",
  color: "#fff",
  backgroundColor: "#b69141",
});

export default function IOCExecutions(props) {
  const { Reload, ReloadClientIOC } = props;
  const [ReloadPage, setReloadPage] = useState(Reload);
  const [rows, setRows] = useState([]);
  const [totalRows, settotalRows] = useState([]);
  const rowsPerPage = 10;
  //const [ExportData, setExportData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [sortModel, setSortModel] = useState([
    { field: "updatedAt", sort: "desc" },
  ]);
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [IDexecute, setIDexecute] = useState("");
  const [signalReload, setsignalReload] = useState(0);
  const [loading, setLoading] = useState(false);

  const cookies = useMemo(() => new Cookies(), []); // Wrap in useMemo with an empty dependency array

  useEffect(() => {
    cookies.set("CurrentPageDataPagination", "16", {
      path: "/",
      SameSite: "none",
      secure: true,
    });
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const url = env2.api + endPoint.allIOC;
    async function GetData() {
      setLoading(true)
      const data = await AxiosFetch("GET", url, source);
      if(data){
        setLoading(false);
      }
      const response = data?.msg ? data.msg : null;
      if (response?.result && response.query) {
        let array = [];
        response.result?.forEach((element) => {
          array.push({
            id: element._id,
            name: element.name,
            tasks: element.tasks,
            client: element.lastName,
            createdBy: element?.createdBy ? element.createdBy.userName : "N/A",
            updatedAt: ConvertDateUtc(element.updatedAt),
            tagStatus: element.isTest,
          });
        });
        setRows(array);
        settotalRows(array);
      } else {
        setRows([]);
        settotalRows([]);

      }
    }
    GetData();
    if (Reload !== 0) setReloadPage(Reload);
    return () => {
      source.cancel();
    };
  }, [cookies, Reload, ReloadPage, ReloadClientIOC, signalReload]);

  const handleOpen = (id) => {
    setIDexecute(id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpenDelete = (id) => {
    setIDexecute(id);
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const requestSearch = (searchValue) => {
    setSearchText(searchValue);
    let filteredRows = [];
    totalRows.forEach((row) => {
      if (row.name.toUpperCase().indexOf(searchValue.toUpperCase()) > -1) {
        filteredRows.push(row);
      }
    });
    setRows(filteredRows);
    if (searchValue === "") {
      setRows(totalRows);
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "updatedAt",
      headerName: "Last modification",
      flex: 0.5,
    },
    {
      field: "tagStatus",
      headerName: "Status",
      type: "singleSelect",
      flex: 0.5,
      minWidth: 150,

      align: "center",
      renderHeader: () => (
        <Box style={{ textAlign: "center", width: "100%" }}>Status</Box>
      ),
      renderCell: (params) => (
        <Chip
          style={{ width: "120px" }}
          variant="outlined"
          label={params.value}
          color={params.value === "tested" ? "primary" : "error"}
        />
      ),
    },
    {
      field: "Launch",
      headerName: "Launch",
      flex: 0.5,
      minWidth: 150,
      align: "center",
      sortable: false,
      filterable: false,
      renderHeader: () => (
        <Box style={{ textAlign: "center", width: "100%" }}>Launch</Box>
      ),
      renderCell: (params) => (
        <>
          {/* <Tooltip title="Launch IoC Validation" arrow> */}
          <ButtonLauncher
            disabled={rolValidation()}
            onClick={handleOpen.bind(this, params.row.id)}
          >
            <img style={{ marginRight: "8px" }} src={launchIcon} alt="" />
            Launch
          </ButtonLauncher>
          {/* </Tooltip> */}
        </>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      type: "actions",
      flex: 0.5,
      minWidth: 150,

      sortable: false,
      filterable: false,
      align: "center",
      renderHeader: () => (
        <Box style={{ textAlign: "center", width: "100%" }}>Actions</Box>
      ),
      renderCell: (params) => (
        <>
          <ModalAdvanceInfo ExecutionInfo={params.row} />
          {/* <Tooltip title="Delete"> */}
          <IconButton
            disabled={rolValidation()}
            className="iconButtonSize"
            onClick={handleOpenDelete.bind(this, params.row.id)}
          >
            <Delete />
          </IconButton>
          {/* </Tooltip> */}
        </>
      ),
    },
  ];

  const DelIOC = async () => {
    const response = await deleteIOC(IDexecute);
    if (response) {
      setOpenDelete(false);
      setsignalReload(signalReload + 1);
    }
  };

  const ExecuteIOC = () => {
    let Request = {
      IOC: IDexecute,
    };
    props.Execute(Request);
    handleClose();
  };

  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };
  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const mobileId = "page-menu-mobile";
  const renderMobileMenu = (
    <Box>
      <Menu
        anchorEl={mobileMoreAnchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        id={mobileId}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={isMobileMenuOpen}
        onClose={handleMobileMenuClose}
      >
        <ModalCreate
          ResetInsider={(e) => props.ResetInsider(e)}
          ReloadPage={ReloadClientIOC}
          Reload={() => {
            setsignalReload(signalReload + 1);
          }}
        />
      </Menu>
    </Box>
  );

  return (
    <Box style={{ width: "100%" }}>
      <Modal open={open} onClose={handleClose}>
        <Box className="contenido" style={{ maxWidth: "500px" }}>
          <Box className="header">
            <Typography className="headerTitle" style={{ textAlign: "center" }}>
              Launch
            </Typography>
            <Typography
              className="comn-label-dash"
              style={{ textAlign: "center" }}
            >
              Do you want to launch this IoC Validation?
            </Typography>
          </Box>

          <Grid container>
            <Grid item md={12}>
              <Box style={{ textAlign: "center" }}>
                <ActionButton onClick={ExecuteIOC.bind()}>Launch</ActionButton>
                <SecondaryButton onClick={handleClose.bind()}>
                  Cancel
                </SecondaryButton>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <GeneralModalDelete
        ExternalOpen={openDelete}
        HeaderText=""
        BodyText="Do you want to Delete this IoC Validation?"
        CloseAction={handleCloseDelete}
        PrimaryAction={DelIOC}
        CancelAction={handleCloseDelete}
      />
      <ThemeProvider theme={pageTheme}>
        <Typography variant="pageTitle">
          <Upcoming className="rt-icon-header" style={{ color: "#c59d48" }} />
          IoC Validation
          <Box
            sx={{
              float: { xs: "none", md: "right" },
              display: { xs: "none", md: "flex" },
            }}
          >
            <ModalCreate
              ResetInsider={(e) => props.ResetInsider(e)}
              ReloadPage={ReloadClientIOC}
              Reload={() => {
                setsignalReload(signalReload + 1);
              }}
            />
          </Box>
          <Box
            sx={{
              float: { xs: "right", md: "none" },
              display: { xs: "inline-block", md: "none" },
            }}
          >
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
              disabled={rolValidation()}
            >
              <MoreVert />
            </IconButton>
          </Box>
        </Typography>
        {renderMobileMenu}
        <Box
          style={{
            width: "100%",
            backgroundColor: "#242933",
            border: " 1px solid #090f1a",
            padding: "15px",
            boxShadow: "0px 4px 4px rgb(0 0 0 / 4%)",
            borderRadius: "14px",
            marginTop: "24px",
            height: "auto",
          }}
        >
          <div style={{ height: "auto", width: "100%" }}>
            <StyledDataGrid
              slotProps={{
                pagination: {
                  ActionsComponent: TablePaginationActions,
                  showFirstButton: true,
                  showLastButton: true,
                },
                toolbar: {
                  value: searchText,
                  onChange: (event) => requestSearch(event.target.value),
                  clearSearch: () => requestSearch(""),
                },              
              }}
              slots={{
                toolbar: QuickSearchToolbar,
                loadingOverlay: CustomLoadingOverlay,
                noRowsOverlay: () => (
                  <GridOverlay>
                    <div>No Data Results</div>
                  </GridOverlay>
                ),
                noResultsOverlay: () => (
                  <GridOverlay>
                    <div>No Results Filter Data</div>
                  </GridOverlay>
                ),
                
              }}
              disableRowSelectionOnClick
              disableColumnSelector
              disableSelectionOnClick
              suppressPaginationPanel={true}
              disableDensitySelector
              rows={rows}
              columns={columns}
              autoHeight={true}
              initialState={{
                pagination: { paginationModel: { pageSize: rowsPerPage } },
              }} 
              loading={loading}
              sortModel={sortModel}
              onSortModelChange={(model) => setSortModel(model)}
              pagination
              pageSizeOptions={[5, 10, 20]}
              density="comfortable"

            />
          </div>
        </Box>
      </ThemeProvider>
    </Box>
  );
}
